var map = {
	"./device_0_1.png": "0f22",
	"./device_0_2.png": "6b91",
	"./device_0_2_v1.png": "f76b",
	"./device_1_1.png": "2a66",
	"./device_1_2.png": "996c",
	"./device_1_2_v1.png": "d015",
	"./device_2_1.png": "dfad",
	"./device_2_2.png": "4b1f",
	"./device_2_2_v1.png": "3631",
	"./device_3_1.png": "fa50",
	"./device_3_2.png": "5f10",
	"./device_3_2_v1.png": "f1cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b7ae";